export default "__VITE_ASSET__C3b8YDlb__"